// removed by extract-text-webpack-plugin
module.exports = {"title":"columns-editor__title___HKR6j","selection-container":"columns-editor__selection-container___1BmkS","cell":"columns-editor__cell___3ntK8"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/columns-editor.scss
// module id = 1302
// module chunks = 0